import { render, staticRenderFns } from "./OrganisationDescriptionForm.vue?vue&type=template&id=142cd752&"
import script from "./OrganisationDescriptionForm.vue?vue&type=script&lang=ts&"
export * from "./OrganisationDescriptionForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports